import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

const Header = ({ darkMode, setDarkMode }) => {
  return (
    <header className="flex justify-between items-center p-4 max-w-5xl mx-auto sticky top-0 bg-navy dark:bg-gray-900 z-50">
      <a href="#top" aria-label="Home">
        <img
          src="/logo.png"
          alt="Victor Akomolafe Logo"
          className="h-10 w-auto object-contain"
        />
      </a>
      <button
        aria-label="Toggle Dark Mode"
        onClick={() => setDarkMode(!darkMode)}
        className="text-softPurple hover:text-glow text-2xl transition-colors"
      >
        {darkMode ? <FaSun /> : <FaMoon />}
      </button>
    </header>
  );
};

export default Header;
